import axios from "axios";
import { getAccessToken, getCompanyId, getUserId } from "./utils.js";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import { fetchFiltersList } from "./filterSettingActions";

export const SEARCH_QUERY = "SEARCH_QUERY";
export const VALIDATE_ACCOUNT = "VALIDATE_ACCOUNT";
export const ADD_ACCOUNT = "ADD_ACCOUNT";
export const CREATE_RULE = "CREATE_RULE";
export const PROGRESS_INFO = "PROGRESS_INFO";
export const VALIDATE_RULE = "VALIDATE_RULE";
export const SET_VALIDRULE = "SET_VALIDRULE";
export const SET_VALIDACCOUNT = "SET_VALIDACCOUNT";
export const RESET_POSTCONTAINER = "RESET_POSTCONTAINER";
export const QUERY_LIST = "QUERY_LIST";
export const CHANGE_BULK_MODE = "CHANGE_BULK_MODE";
export const CHANGE_ACTIVE_TAB = "CHANGE_ACTIVE_TAB";
export const CHANGE_VIEW_QUERY_MODE = "CHANGE_VIEW_QUERY_MODE";
export const EDIT_QUERY = "EDIT_QUERY";
export const EDIT_MODE = "EDIT_MODE";
export const SUPPORTED_LANGUAGES = "SUPPORTED_LANGUAGES";
export const TRANSLATE_TEXT = "TRANSLATE_TEXT";
export const UPDATE_PROGRESS_INFO = "UPDATE_PROGRESS_INFO";
export const JOIN_ACCOUNT = "JOIN_ACCOUNT";

export const SET_COUNTRIES = "SET_COUNTRIES";
export const SET_BOOLEAN = "SET_BOOLEAN";
export const SET_PLATFORM = "SET_PLATFORM";
export const SET_ACCOUNT = "SET_ACCOUNT";
export const SET_LOCATION = "SET_LOCATION";
export const SET_ENTITY = "SET_ENTITY";
export const SET_PUBLICATION = "SET_PUBLICATION";
export const SET_PULL_COMMENTS = "SET_PULL_COMMENTS";
export const RESET_ACCOUNT_FORM = "RESET_ACCOUNT_FORM";
export const SET_ACCOUNT_LIST = "SET_ACCOUNT_LIST";
export const SET_ACCOUNT_LIST_DATA = "SET_ACCOUNT_LIST_DATA";
export const SET_BULK_INPUT_VALUE = "SET_BULK_INPUT_VALUE";
export const FETCH_NEW_DATA = "FETCH_NEW_DATA";
export const SET_SELECTED_TOPIC = "SET_SELECTED_TOPIC";
export const SET_SELECTED_TOPIC_COLOR = "SET_SELECTED_TOPIC_COLOR";
export const SET_NEW_TOPIC = "SET_NEW_TOPIC";
export const SET_NEW_TOPIC_COLOR = "SET_NEW_TOPIC_COLOR";
export const SET_SUB_TOPIC = "SET_SUB_TOPIC";
export const SET_SUB_TOPIC_COLOR = "SET_SUB_TOPIC_COLOR";
export const RESET_EDIT_MODE = "RESET_EDIT_MODE";
export const UPDATE_KEYWORD_TYPE = "UPDATE_KEYWORD_TYPE";
export const SHOW_SAMPLE_DATA = "SHOW_SAMPLE_DATA";
export const TOGGLE_ACCOUNT_BLOCK = "TOGGLE_ACCOUNT_BLOCK";
export const TOGGLE_KEYWORD_BLOCK = "TOGGLE_KEYWORD_BLOCK";
export const TOGGLE_DATA__LOSS_ALERT = "TOGGLE_DATA__LOSS_ALERT";
export const TOGGLE_SHOW_SAMPLE_BTN = "TOGGLE_SHOW_SAMPLE_BTN";
export const GET_PROGRESS = "GET_PROGRESS";
export const SET_TIKTOK_RULE_NAME = "SET_TIKTOK_RULE_NAME";
export const SET_TIKTOK_KEYWORD = "SET_TIKTOK_KEYWORD";
export const SET_POST_URL = "SET_POST_URL";
export const SET_POST_COUNTRY = "SET_POST_COUNTRY";
export const SET_POST_LIST_DATA = "SET_POST_LIST_DATA";
export const SET_VALID_COUNTRY = "SET_VALID_COUNTRY";
export const SET_VALID_ENTITY = "SET_VALID_ENTITY";
export const SET_PLATFORM_QB = "SET_PLATFORM_QB";

export function searchQueryResults(param) {
    let params = new URLSearchParams();
    params.append("location", param.countries);
    params.append("offset", 1);
    params.append("custom_query", param.query);
    params.append("data", 1);
    params.append("public_data", 1);
    params.append("duration", 7);
    params.append("access-token", getAccessToken());
    params.append("recordsPerPage", 50);
    params.append("aggs", "conversation-over-time-platform-v7");
    let res = axios({
        method: "post",
        url: getUrl("raw_data"),
        data: params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: SEARCH_QUERY,
        payload: res,
    };
}

export function validateAccount(param, platform) {
    let res = axios({
        method: "post",
        url: getUrl("validate_account"),
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            if (platform === "tiktok") {
                if (res.data.records[0].account_exist) {
                    toast.success("Account verified successfully.Please proceed for further steps");
                    res.data.status = true;
                    return res.data;
                } else {
                    toast.error("Account is not valid");
                    res.data.status = false;
                    return res.data;
                }
            }
            if (res.data.status) {
                toast.success("Account verified successfully.Please proceed for further steps");
            } else {
                toast.error("Account is not valid");
                return res.data?.errorList;
            }
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });

    return {
        type: VALIDATE_ACCOUNT,
        payload: res,
    };
}
export function addAccount(param) {
    let res = axios({
        method: "post",
        url: getUrl("validate_account"),
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            if (res.data.status) {
                toast.success("Account added successfuly.");
            } else {
                toast.error("Account is not valid");
                return res;
            }
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });

    return {
        type: ADD_ACCOUNT,
        payload: res,
    };
}

export function createRule(param) {
    param["access-token"] = getAccessToken();
    let updateQuery = false;
    if (param["subtopic_id"]) {
        updateQuery = true;
    }
    let new_param = {};
    new_param["accounts"] = param["accountList"];
    new_param["update_query"] = updateQuery;
    delete param.accountList;
    return function (dispatch) {
        dispatch({
            type: "CREATE_RULE_PENDING",
        });
        let res = axios({
            method: "post",
            url: getUrl("rule_create"),
            data: param,
            cache: false,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "CREATE_RULE_FULFILLED",
                    payload: res.data,
                });
                if (updateQuery) {
                    dispatch(editQuery({}));
                }
                new_param["research_query_id"] = res.data.data.id;
                dispatch(addAccountAfterCreateRule(new_param));
                dispatch(fetchCreatedQueriesList());
                return res.data;
            })
            .catch((err) => {
                toast.error(err.response.data.message);
                dispatch({
                    type: "CREATE_RULE_REJECTED",
                    payload: err.response.data,
                });
                throw err;
            });
    };
}

export function gettingStartedProgress() {
    return function (dispatch) {
        axios
            .get(`${getUrl("get_progress")}`, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: GET_PROGRESS,
                    payload: response?.data?.data,
                });
            })
            .catch((error) => {
                console.log(error);
                toast.error("Error in retaining your progress on the platform");
            });
    };
}

export function addAccountAfterCreateRule(param) {
    let updateQuery = param["update_query"];
    delete param.update_query;
    return function (dispatch) {
        let progressBarParams = {};
        let config = {};
        config["queryCreated"] = 1;
        progressBarParams["company_id"] = getCompanyId();
        progressBarParams["user_id"] = getUserId();
        progressBarParams["progress_config"] = config;
        dispatch({
            type: "JOIN_ACCOUNT_PENDING",
        });
        let res = axios({
            method: "post",
            url: getUrl("add_account"),
            data: param,
            cache: false,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "JOIN_ACCOUNT_FULFILLED",
                    payload: res.data,
                });
                if (updateQuery) {
                    toast.success("Query updated successfully.");
                } else {
                    toast.success("Query created successfully.");
                }
                dispatch(updateProgressBarInfo(progressBarParams));
                dispatch(fetchFiltersList());
                dispatch(changeViewQueryMode(true));
                dispatch(gettingStartedProgress());
                return res.data;
            })
            .catch((err) => {
                toast.error(err.response.data.message);
                dispatch({
                    type: "JOIN_ACCOUNT_REJECTED",
                    payload: err.response.data,
                });
                throw err;
            });
    };
}

export function fetchProgressBarInfo() {
    let res = axios({
        method: "get",
        url: `${getUrl("progressbar_info")}&access-token=${getAccessToken()}`,
        cache: false,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: PROGRESS_INFO,
        payload: res,
    };
}
export function updateProgressBarInfo(params) {
    return function (dispatch) {
        let res = axios({
            method: "post",
            url: `${getUrl("update_progressbar")}`,
            data: params,
            cache: false,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch(fetchProgressBarInfo());
                return res.data;
            })
            .catch((err) => {
                toast.error(err.response.data.message);
                throw err;
            });
    };
}
export function ruleValidate(param, val) {
    let res = axios({
        method: "post",
        url: getUrl("validate_rule"),
        data: param,
        cache: false,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            if (res.data.data.error) {
                toast.error("Invalid Boolean");
            } else {
                if (!val) toast.success("No error with the Query");
            }
            // console.log("dataa", res);
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response?.data.message);
            return err;
        });
    return {
        type: VALIDATE_RULE,
        payload: res,
    };
}
export function setValidRule(flag) {
    return {
        type: "SET_VALIDRULE",
        payload: flag,
    };
}

export function setValidAccount(flag) {
    return {
        type: "SET_VALIDACCOUNT",
        payload: flag,
    };
}
export function resetPostContainer() {
    return {
        type: "RESET_POSTCONTAINER",
        payload: [],
    };
}

export function fetchCreatedQueriesList() {
    let res = axios({
        method: "get",
        url: `${getUrl("query_list")}&access-token=${getAccessToken()}&includes=topicsAndSubtopics`,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "QUERY_LIST",
        payload: res,
    };
}

export function enableDataFetch(param) {
    return function (dispatch) {
        axios
            .post(getUrl("datafetch_enable"), param, {
                cache: false,
                headers: { "Content-Type": "application/json;charset=UTF-8" },
            })
            .then((res) => {
                if (res.data.status === "success") {
                    toast.success("Started data pull for query");
                    dispatch(fetchCreatedQueriesList());
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
}
export function disableDataFetch(param) {
    return function (dispatch) {
        axios
            .post(getUrl("datafetch_disable"), param, {
                cache: false,
                headers: { "Content-Type": "application/json;charset=UTF-8" },
            })
            .then((res) => {
                if (res.data.status === "success") {
                    toast.success("Stopped data pull for query");
                    dispatch(fetchCreatedQueriesList());
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
}

export function deleteRule(param) {
    let new_param = {};
    new_param["research_query_id"] = param.research_query_id;
    return function (dispatch) {
        axios
            .delete(`${getUrl("rule_delete")}${param.id}?access-token=${getAccessToken()}`, {
                cache: false,
                headers: { "Content-Type": "application/json" },
            })
            .then((res) => {
                if (res.data.status == "error") {
                    let alert_report = JSON.parse(res.data.alert_report);
                    let message =
                        "You can not delete this Boolean as this boolean is associated to " +
                        alert_report.type +
                        " " +
                        alert_report.name +
                        " . You need to remove the association with the " +
                        alert_report.type.toLowerCase() +
                        " first in order to delete the boolean.";
                    toast.error(message);
                    return res.data;
                }
                toast.success("Query deleted sucessfully");
                dispatch(deleteAccount(new_param));
                dispatch(fetchFiltersList());
            })
            .catch((err) => {
                toast.error(err.response.data.message);
                throw err;
            });
    };
}

export function deleteAccount(param) {
    return function (dispatch) {
        axios
            .post(getUrl("delete_account"), param, {
                cache: false,
                headers: { "Content-Type": "application/json;charset=UTF-8" },
            })
            .then((res) => {
                if (res.data.status === true) {
                    dispatch(fetchCreatedQueriesList());
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
}

export function changeViewQueryMode(flag) {
    return {
        type: "CHANGE_VIEW_QUERY_MODE",
        payload: flag,
    };
}

export function changeBulkMode(flag) {
    return {
        type: "CHANGE_BULK_MODE",
        payload: flag,
    };
}
export function changeCreateQueryActiveTab(flag) {
    return {
        type: "CHANGE_ACTIVE_TAB",
        payload: flag,
    };
}
export function editQuery(val) {
    return {
        type: "EDIT_QUERY",
        payload: val,
    };
}

export function getAllSupportedLanguages() {
    let res = axios({
        method: "get",
        url: getUrl("supported_languages"),
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err?.response?.data?.message);
            throw err;
        });

    return {
        type: "SUPPORTED_LANGUAGES",
        payload: res,
    };
}

export function googleTextTranslate(params) {
    let res = axios({
        method: "post",
        url: getUrl("translate_text"),
        data: params,
        cache: false,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });

    return {
        type: "TRANSLATE_TEXT",
        payload: res,
    };
}

export function setLocation(values) {
    return {
        type: "SET_COUNTRIES",
        payload: values,
    };
}

export function setValidCountry(values) {
    return {
        type: "SET_VALID_COUNTRY",
        payload: values,
    };
}

export function setValidEntity(values) {
    return {
        type: "SET_VALID_ENTITY",
        payload: values,
    };
}

export function setBoolean(values) {
    return {
        type: "SET_BOOLEAN",
        payload: values,
    };
}
export function setPlatform(values) {
    return {
        type: "SET_PLATFORM",
        payload: values,
    };
}

export function setAccount(values) {
    return {
        type: "SET_ACCOUNT",
        payload: values,
    };
}

export function setAccountURL(values) {
    return {
        type: "SET_ACCOUNT_URL",
        payload: values,
    };
}

export function setPostUrl(values) {
    return {
        type: "SET_POST_URL",
        payload: values,
    };
}

export function setPostCountry(values) {
    return {
        type: "SET_POST_COUNTRY",
        payload: values,
    };
}

export function setAccountLocation(values) {
    return {
        type: "SET_LOCATION",
        payload: values,
    };
}

export function setEntity(values) {
    return {
        type: "SET_ENTITY",
        payload: values,
    };
}

export function setTiktokRuleName(value) {
    return {
        type: "SET_TIKTOK_RULE_NAME",
        payload: value,
    };
}

export function setTiktokKeyword(value) {
    const keywordRegEx = /^"[\w\s#]+"(\sOR\s"[\w\s#]+")*$/;
    if (!keywordRegEx.test(value)) {
        return {
            type: "SET_TIKTOK_KEYWORD",
            payload: { value, isValid: false },
        };
    }

    return {
        type: "SET_TIKTOK_KEYWORD",
        payload: { value, isValid: true },
    };
}

export function setPublication() {
    return {
        type: "SET_PUBLICATION",
    };
}

export function setPullComments() {
    return {
        type: "SET_PULL_COMMENTS",
    };
}
export function resetAccountForm() {
    return {
        type: "RESET_ACCOUNT_FORM",
    };
}

export function setAccountList(values) {
    return {
        type: "SET_ACCOUNT_LIST",
        payload: values,
    };
}

export function setAccountListData(values) {
    return {
        type: "SET_ACCOUNT_LIST_DATA",
        payload: values,
    };
}

export function setPostListData(values) {
    return {
        type: "SET_POST_LIST_DATA",
        payload: values,
    };
}

export function setBulkFileldValue(values) {
    return {
        type: "SET_BULK_INPUT_VALUE",
        payload: values,
    };
}

export function setFetchNewData(values) {
    return {
        type: "FETCH_NEW_DATA",
        payload: values,
    };
}
export function setSelectedTopic(values) {
    return {
        type: "SET_SELECTED_TOPIC",
        payload: values,
    };
}
export function setSelectedTopicColor(values) {
    return {
        type: "SET_SELECTED_TOPIC_COLOR",
        payload: values,
    };
}
export function setNewTopicName(values) {
    return {
        type: "SET_NEW_TOPIC",
        payload: values,
    };
}
export function setNewTopicColor(values) {
    return {
        type: "SET_NEW_TOPIC_COLOR",
        payload: values,
    };
}
export function setSubTopicName(values) {
    return {
        type: "SET_SUB_TOPIC",
        payload: values,
    };
}
export function setSubTopicColor(values) {
    return {
        type: "SET_SUB_TOPIC_COLOR",
        payload: values,
    };
}
export function resetEditQueryMode() {
    return {
        type: "RESET_EDIT_MODE",
    };
}
export function setKeywordTypeValue(values, type) {
    return {
        type: "UPDATE_KEYWORD_TYPE",
        payload: values,
        keywordType: type,
    };
}
export function setShowSample(value) {
    return {
        type: "SHOW_SAMPLE_DATA",
        payload: value,
    };
}
export function setKeywordExpandBlock(value) {
    return {
        type: "TOGGLE_KEYWORD_BLOCK",
        payload: value,
    };
}
export function setAccountExpandBlock(value) {
    return {
        type: "TOGGLE_ACCOUNT_BLOCK",
        payload: value,
    };
}
export function setPlatformQB(value) {
    return {
        type: "SET_PLATFORM_QB",
        payload: value,
    };
}

export function toggleDataLossAlertModal() {
    return {
        type: "TOGGLE_DATA__LOSS_ALERT",
    };
}
export function toggleSampleButton() {
    return {
        type: "TOGGLE_SHOW_SAMPLE_BTN",
    };
}

export function getYoutubeChannelId(data) {
    let res = axios({
        method: "post",
        url: `${getUrl("social")}/get-youtube-channel-id?access-token=${getAccessToken()}`,
        data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });

    return {
        type: "GET_YOUTUBE_CHANNEL",
        payload: res,
    };
}
